import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '@app/app-material.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { ComponentsModule } from '@shared/components/components.module';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { PneusController } from './controllers';
import { PneusComponent } from './pages/pneus/pneus.component';
import { AnexoPneuComponent } from './components/anexo-pneu/anexo-pneu.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [PneusComponent, AnexoPneuComponent],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), PneusController],
})
export class PneusModule {}
